var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-subtle"
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s(_vm.placeholder + '.')
    }
  }), _vm._v(" "), (_vm.inputType == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atValue),
      expression: "atValue"
    }],
    attrs: {
      "id": _vm.id,
      "type": "text"
    },
    domProps: {
      "value": (_vm.atValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.atValue = $event.target.value
      }
    }
  }) : (_vm.inputType == 'date') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atValue),
      expression: "atValue"
    }],
    attrs: {
      "id": _vm.id,
      "type": "date"
    },
    domProps: {
      "value": (_vm.atValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.atValue = $event.target.value
      }
    }
  }) : (_vm.inputType == 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atValue),
      expression: "atValue"
    }],
    attrs: {
      "id": _vm.id,
      "type": "number"
    },
    domProps: {
      "value": (_vm.atValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.atValue = $event.target.value
      }
    }
  }) : (_vm.inputType == 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atValue),
      expression: "atValue"
    }],
    attrs: {
      "id": _vm.id,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.atValue) ? _vm._i(_vm.atValue, null) > -1 : (_vm.atValue)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.atValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.atValue = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.atValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.atValue = $$c
        }
      }
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atValue),
      expression: "atValue"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.atValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.atValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input-type', {
    attrs: {
      "placeholder": "wut"
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.atType),
      callback: function($$v) {
        _vm.atType = $$v
      },
      expression: "atType"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26afdc3d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueLiteral.vue
// module id = 65
// module chunks = 1